import {
  CAR_COMPANY_REDUCER,
  UPDATE_CAR_LIST_REDUCER,
} from "store/actionTypes";
import { ActionType, CarCompanyReducerModal } from "utils/modals";

export const CarCompanyReducer = (
  state: CarCompanyReducerModal = new CarCompanyReducerModal(),
  action: ActionType
) => {
  switch (action.type) {
    case CAR_COMPANY_REDUCER:
      return { ...state, ...action.payload };
    case UPDATE_CAR_LIST_REDUCER:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
